import React, { FC } from 'react'

import { IconOneNumberProps } from './IconOneNumber.types'
import * as Styled from './styles/IconOneNumber.style'

import { nonThemeableRules } from '../../ruleSet'

const IconOneNumber: FC<IconOneNumberProps> = ({
  size = nonThemeableRules.defaultSize as number as IconOneNumberProps['size'],
  isResponsive = false,
}: IconOneNumberProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M19.078 35.278a15.545 15.545 0 1 1 17.81-6.058v0C34.184 33.25 24 43 24 43'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M24 43V17.648a1.25 1.25 0 0 0-1.25-1.25h-2.135c-.237 0-.47.066-.67.192L14.1 20.288A1.25 1.25 0 0 0 13.7 22l.935 1.535a1.25 1.25 0 0 0 1.735.407l2.707-1.71v13.05'
          stroke='#E60000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconOneNumber
